export default function install() {
// Runs in the page's MAIN world at document_start on MIDI pages.
//
// The MIDI app exposes its internals (window.__md = { store, engine, editor })
// only when the URL contains `?debug`. This adds the flag before the app boots,
// then puts the original URL back as soon as the app has published the hook, so
// the address bar and the user's bookmarks are unaffected.
(() => {
  const url = new URL(location.href);
  if (url.searchParams.has('debug')) return;
  const original = location.href;
  url.searchParams.set('debug', '');
  history.replaceState(history.state, '', url.toString().replace(/debug=(&|$)/, 'debug$1'));

  let value;
  Object.defineProperty(window, '__md', {
    configurable: true,
    enumerable: false,
    get: () => value,
    set(v) {
      value = v;
      // keep it a plain property from here on
      Object.defineProperty(window, '__md', { value: v, writable: true, configurable: true, enumerable: false });
      try {
        if (location.href.includes('debug')) history.replaceState(history.state, '', original);
      } catch {
        /* ignore */
      }
    },
  });

  // if the app never sets the hook (e.g. it failed to boot), still restore the URL
  setTimeout(() => {
    try {
      if (!value && new URL(location.href).searchParams.has('debug')) history.replaceState(history.state, '', original);
    } catch {
      /* ignore */
    }
  }, 15000);
})();

}
